module.exports = __webpack_public_path__ + "static/97-f895c384c1941760c8e7122f429759b0.png";